import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { RootState } from "app/lib/store/store";
import { useDispatch, useSelector } from "react-redux";
import {
  nextStep,
  prevStep,
  addStepsData,
} from "app/lib/store/slices/steps/loanTypesSteps";

import MainTitle from "app/components/common/typography/MainTitle";
import ContinueButton from "app/components/common/buttons/Continue";
import PreviousButtom from "app/components/common/buttons/Previous";
import ProgressBar from "app/components/common/progressbar/ProgressBar";
import SubTitle from "app/components/common/typography/SubTitle";
import { LiabilitiesForm } from "app/utils/applicant/types/types";
import LiabilitiesInputs from "app/components/Individual/applicant/liabilities/LiabilitiesInputs";

const Liabilities: React.FC = () => {
  const { applicants, ...remaingData } = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );
  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<LiabilitiesForm>({
    defaultValues: {
      creditCardLimits: 0,
      sumOfAllOtherLoans: 0,
      totalMonthlyRepaymentsOnOtherLoans: 0,
    },
  });

  const onSubmit = (data: LiabilitiesForm) => {
    dispatch(
      addStepsData({
        ...remaingData,
        applicants: {
          ...applicants,
          liabilities: {
            ...applicants?.liabilities,
            creditCardLimits: Number(data.creditCardLimits) || 0,
            sumOfAllOtherLoans: Number(data.sumOfAllOtherLoans) || 0,
            totalMonthlyRepaymentsOnOtherLoans:
              Number(data.totalMonthlyRepaymentsOnOtherLoans) || 0,
          },
        },
      })
    );
    dispatch(nextStep());
  };

  useEffect(() => {
    if (applicants?.liabilities || applicants?.expenses) {
      reset({
        creditCardLimits: applicants?.liabilities?.creditCardLimits,
        sumOfAllOtherLoans: applicants?.liabilities?.sumOfAllOtherLoans,
        totalMonthlyRepaymentsOnOtherLoans:
          applicants?.liabilities?.totalMonthlyRepaymentsOnOtherLoans,
      });
    }
  }, [applicants, reset]);

  return (
    <>
      <ProgressBar progress={100} />
      <div className="w-full  sm:w-[70%] xl:w-[55%]  mx-auto text-center px-4 sm:px-0">
        <MainTitle title="Liabilities" />
        <SubTitle title="Please outline your total credit card limit and all other personal/property loans" />
        <form onSubmit={handleSubmit(onSubmit)}>
          <LiabilitiesInputs
            control={control}
            errors={errors}
            groups={[
              [
                {
                  label: "Total credit card limits",
                  name: "creditCardLimits",
                  required: false,
                  tooltip:
                    "Combined limits of all borrowers, including store cards.",
                },
              ],
              [
                {
                  label: "Sum of all other loans",
                  name: "sumOfAllOtherLoans",
                  required: false,
                  tooltip:
                    "Include all loan amounts for car loans, personal loans, or student loans.",
                },
                {
                  label: "Total monthly repayments on other loans",
                  name: "totalMonthlyRepaymentsOnOtherLoans",
                  required: false,
                  tooltip:
                    "Include all borrowers car loans, personal loans or student loan repayments.",
                },
              ],
            ]}
          />

          <div className="flex justify-between my-10">
            <PreviousButtom onClick={() => dispatch(prevStep())}>
              Previous
            </PreviousButtom>
            <ContinueButton type="submit">Next</ContinueButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default Liabilities;
